/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Drastic_Tech_Embed_Start_LogInputs */



/**
* | output |
* | --- |
* | "-----Embedding closed captioning into {name}-----" |
*
* @param {Drastic_Tech_Embed_Start_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_embed_start_log = /** @type {((inputs: Drastic_Tech_Embed_Start_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Embed_Start_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`-----Integration des sous-titres dans ${i?.name}-----`)
	if (locale === "de") return /** @type {LocalizedString} */ (`-----Einbetten von Untertiteln in ${i?.name}-----`)
	if (locale === "it") return /** @type {LocalizedString} */ (`-----Incorporamento dei sottotitoli in ${i?.name}-----`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Встраивание субтитров в ${i?.name}-----`)
	if (locale === "es") return /** @type {LocalizedString} */ (`-----Incorporación de subtítulos en ${i?.name}-----`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`-----将隐藏式字幕嵌入${i?.name}-----`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`-----クローズドキャプションを${i?.name}に埋め込む-----`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`-----${i?.name} में क्लोज्ड कैप्शनिंग एम्बेड करना-----`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`-----Incorporando legendas ocultas em ${i?.name}-----`)
	return /** @type {LocalizedString} */ (`-----Embedding closed captioning into ${i?.name}-----`)
});